import { render, staticRenderFns } from "./ImportSubjects.vue?vue&type=template&id=298e304d&scoped=true"
import script from "@/views/Curricula/ImportSubjects.ts?vue&type=script&lang=ts&external"
export * from "@/views/Curricula/ImportSubjects.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Curricula/import-subjects.scss?vue&type=style&index=0&id=298e304d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298e304d",
  null
  
)

export default component.exports